import { KText } from '@/ui-library/components';
import { Flex } from '@chakra-ui/react';
import { Upload01 } from '@kula-ai/icons-core';
import { useRef } from 'react';

// for replace control
export const CustomOpenFileTool = ({
  onFileSelect,
  accept = 'application/pdf',
}: {
  onFileSelect: (file: File) => void;
  accept?: string;
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileSelect = (e: any) => {
    if (e?.target?.files?.length) {
      // @ts-expect-error Array.from produces File[] here
      onFileSelect(Array.from(e.target.files));
    }

    // Reset input to allow re-selecting the same file
    e.target.value = '';
  };

  return (
    <>
      <Flex
        gap="4px"
        alignItems="center"
        onClick={handleButtonClick}
        ml="2px"
        p="2px"
        _hover={{
          bg: 'secondary-50',
        }}
        cursor="pointer"
        borderRadius="4px"
      >
        <Upload01 size={20} />
        <KText>Replace</KText>
      </Flex>
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        onChange={handleFileSelect}
        style={{ display: 'none' }}
      />
    </>
  );
};
